var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconRank3St = function SvgIconRank3St(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-rank-3st_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-3st_svg__b)",
    d: "M10.745 25.064c1.769 1.731 2.878 3.817 3.262 5.827.08.421-.566 1.08-.988 1.01-2.018-.34-4.127-1.405-5.896-3.137s-2.879-3.817-3.263-5.827c-.08-.421.566-1.081.988-1.01 2.018.34 4.127 1.405 5.897 3.137"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-3st_svg__c)",
    d: "M10.745 25.064c1.769 1.731 2.878 3.817 3.262 5.827.08.421-.566 1.08-.988 1.01-2.018-.34-4.127-1.405-5.896-3.137s-2.879-3.817-3.263-5.827c-.08-.421.566-1.081.988-1.01 2.018.34 4.127 1.405 5.897 3.137"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-3st_svg__d)",
    d: "M13.144 20.96c1.418 2.772 1.909 5.703 1.563 8.254-.072.534-1.106 1.064-1.582.81-2.27-1.212-4.362-3.325-5.78-6.097s-1.909-5.704-1.563-8.255c.072-.534 1.106-1.064 1.582-.81 2.27 1.213 4.361 3.325 5.78 6.097"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-3st_svg__e)",
    d: "M5.754 18.71c.188 1.713.71 3.495 1.59 5.216 1.42 2.772 3.51 4.885 5.78 6.097.476.254 1.51-.276 1.583-.81.345-2.55-.145-5.482-1.563-8.254a15.2 15.2 0 0 0-3.105-4.162z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-3st_svg__f)",
    d: "M29.256 25.064c-1.77 1.731-2.88 3.817-3.263 5.827-.08.421.566 1.08.988 1.01 2.018-.34 4.127-1.405 5.896-3.137s2.88-3.817 3.263-5.827c.08-.421-.566-1.081-.988-1.01-2.018.34-4.127 1.405-5.896 3.137"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-3st_svg__g)",
    d: "M29.256 25.064c-1.77 1.731-2.88 3.817-3.263 5.827-.08.421.566 1.08.988 1.01 2.018-.34 4.127-1.405 5.896-3.137s2.88-3.817 3.263-5.827c.08-.421-.566-1.081-.988-1.01-2.018.34-4.127 1.405-5.896 3.137"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-3st_svg__h)",
    d: "M26.857 20.96c-1.419 2.772-1.91 5.703-1.564 8.254.073.534 1.107 1.064 1.582.81 2.271-1.212 4.362-3.325 5.78-6.097s1.91-5.704 1.564-8.255c-.072-.534-1.107-1.064-1.582-.81-2.271 1.213-4.362 3.325-5.78 6.097"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-3st_svg__i)",
    d: "M34.246 18.71c-.188 1.713-.71 3.495-1.59 5.216-1.42 2.772-3.51 4.885-5.78 6.097-.476.254-1.51-.276-1.583-.81-.345-2.55.145-5.482 1.564-8.254a15.2 15.2 0 0 1 3.105-4.162z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-3st_svg__j)",
    d: "M20 40c6.888 0 12.473-5.584 12.473-12.473 0-6.888-5.585-12.472-12.473-12.472S7.527 20.639 7.527 27.527C7.527 34.416 13.111 40 20 40"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-3st_svg__k)",
    d: "M20 37.47c5.49 0 9.942-4.452 9.942-9.942S25.49 17.586 20 17.586c-5.49 0-9.941 4.45-9.941 9.942 0 5.49 4.45 9.941 9.941 9.941"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-3st_svg__l)",
    d: "M20 36.062a8.535 8.535 0 1 0 0-17.07 8.535 8.535 0 0 0 0 17.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-3st_svg__m)",
    d: "M7.527 27.528C7.527 34.416 13.111 40 20 40c6.888 0 12.473-5.584 12.473-12.472l-.002-.145H7.529z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-3st_svg__n)",
    d: "M23.498 39.505a12.5 12.5 0 0 0 8.342-8.044l-6.075-6.074-1.37.067-3.695-3.696L16.195 32.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-3st_svg__o)",
    d: "m25.114 24.815-2.446-.59a.94.94 0 0 1-.557-.388l-1.41-2.084a.93.93 0 0 0-.701-.41.93.93 0 0 0-.7.41l-1.41 2.084a.94.94 0 0 1-.558.387l-2.446.591a.94.94 0 0 0-.52 1.49l1.546 1.986a.94.94 0 0 1 .195.65l-.193 2.509a.94.94 0 0 0 1.256.955l2.366-.857a.94.94 0 0 1 .464-.044.94.94 0 0 1 .464.044l2.366.857a.94.94 0 0 0 1.257-.955l-.194-2.51a.94.94 0 0 1 .195-.65l1.547-1.984a.94.94 0 0 0-.52-1.491"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-3st_svg__p)",
    d: "m20.464 31.548 2.366.857a.94.94 0 0 0 1.257-.955l-.194-2.51a.94.94 0 0 1 .195-.65l1.547-1.984a.94.94 0 0 0-.52-1.491l-2.447-.59a.94.94 0 0 1-.557-.388l-1.41-2.084a.93.93 0 0 0-.701-.41v10.16a.94.94 0 0 1 .464.045"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-3st_svg__q)",
    d: "m25.114 24.817-2.446-.591a1 1 0 0 1-.237-.093l-6.235 8.065c.244.236.613.34.974.21l2.366-.858a.94.94 0 0 1 .464-.044.94.94 0 0 1 .463.044l2.366.857a.94.94 0 0 0 1.257-.956l-.194-2.509a.94.94 0 0 1 .196-.65l1.547-1.984a.94.94 0 0 0-.52-1.491"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-3st_svg__r)",
    d: "m14.886 24.817 2.446-.591a1 1 0 0 0 .236-.093l6.236 8.065a.94.94 0 0 1-.974.21l-2.366-.858a.94.94 0 0 0-.464-.044.94.94 0 0 0-.464.044l-2.366.857a.94.94 0 0 1-1.257-.956l.194-2.509a.94.94 0 0 0-.195-.65l-1.547-1.984a.94.94 0 0 1 .52-1.491"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-3st_svg__s)",
    d: "M14.235 25.383a.93.93 0 0 0 .13.924l1.547 1.985a.94.94 0 0 1 .195.65l-.194 2.509a.94.94 0 0 0 1.257.955l2.366-.857a.94.94 0 0 1 .464-.044.94.94 0 0 1 .464.044l2.366.857a.94.94 0 0 0 1.257-.955l-.194-2.51a.9.9 0 0 1 .05-.378z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-3st_svg__t)",
    d: "M25.767 25.383a.93.93 0 0 1-.131.924l-1.547 1.985a.94.94 0 0 0-.195.65l.194 2.509a.94.94 0 0 1-1.257.955l-2.366-.857a.94.94 0 0 0-.464-.044.94.94 0 0 0-.464.044l-2.365.857a.94.94 0 0 1-1.258-.955l.194-2.51a.9.9 0 0 0-.05-.378z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-3st_svg__u)",
    d: "m20 15.055-.155.002-1.925 1.925 14.052 14.051c.325-1.112.5-2.288.5-3.506 0-6.888-5.584-12.472-12.472-12.472"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-3st_svg__v)",
    d: "M12.47.258v6.588l7.53 7.53 7.53-7.53V.258z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-3st_svg__w)",
    d: "M12.47.258v2.05l7.505 7.504a.036.036 0 0 0 .05 0l7.505-7.504V.258z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-3st_svg__x)",
    d: "M20 10.996c-.31 0-.62-.119-.857-.355L12.471 3.97v2.874l7.53 7.53 7.528-7.53V3.969l-6.672 6.672a1.2 1.2 0 0 1-.857.355"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-3st_svg__y)",
    d: "M12.47.258v2.05l7.505 7.504a.036.036 0 0 0 .05 0l7.505-7.504V.258z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-3st_svg__z)",
    d: "M20 10.996c-.31 0-.62-.119-.857-.355L12.471 3.97v2.874l7.53 7.53 7.528-7.53V3.969l-6.672 6.672a1.2 1.2 0 0 1-.857.355"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-3st_svg__A)",
    d: "M20 10.996c.31 0 .62-.119.857-.355L27.53 3.97v2.874L20 14.373l-7.53-7.53V3.969l6.673 6.672c.236.236.547.355.857.355"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-3st_svg__B)",
    d: "M19.175 12.666 12.767 6.26a1.23 1.23 0 0 0-1.74 1.74L20 16.972l8.974-8.973a1.23 1.23 0 0 0-1.74-1.74l-6.408 6.407a1.17 1.17 0 0 1-1.651 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-3st_svg__C)",
    d: "m11.028 6.273 8.028 8.029a1.336 1.336 0 0 0 1.89 0l8.028-8.029.006-.007-.006-.007a1.23 1.23 0 0 0-1.74 0l-6.408 6.407a1.17 1.17 0 0 1-1.651 0L12.768 6.26a1.23 1.23 0 0 0-1.74 0l-.007.007z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-3st_svg__D)",
    d: "m20 16.975 6.334-6.334h-3.48l-2.028 2.028a1.17 1.17 0 0 1-1.652 0l-2.028-2.028h-3.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-3st_svg__E)",
    d: "m19.216 16.187.784.784 8.034-8.033h-3.48l-3.728 3.727a1.167 1.167 0 0 1-1.61.038z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-3st_svg__F)",
    d: "M20 17.843a2.941 2.941 0 1 0 0-5.882 2.941 2.941 0 0 0 0 5.882"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-3st_svg__G)",
    d: "M20 16.591a1.686 1.686 0 1 0 0-3.372 1.686 1.686 0 0 0 0 3.372"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-3st_svg__H)",
    d: "M28.667 2.928H11.333a.9.9 0 0 1-.901-.902V.902c0-.498.403-.902.901-.902h17.334c.498 0 .902.404.902.902v1.124a.9.9 0 0 1-.902.902"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-3st_svg__b",
    x1: 6.084,
    x2: 8.648,
    y1: 22.48,
    y2: 26.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-3st_svg__c",
    x1: 6.445,
    x2: 9.181,
    y1: 26.036,
    y2: 27.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-3st_svg__d",
    x1: 10.47,
    x2: 10.111,
    y1: 18.171,
    y2: 24.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-3st_svg__e",
    x1: 9.654,
    x2: 11.205,
    y1: 21.39,
    y2: 24.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-3st_svg__f",
    x1: 33.91,
    x2: 31.346,
    y1: 22.491,
    y2: 26.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-3st_svg__g",
    x1: 33.549,
    x2: 30.813,
    y1: 26.047,
    y2: 27.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-3st_svg__h",
    x1: 29.524,
    x2: 29.884,
    y1: 18.181,
    y2: 24.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-3st_svg__i",
    x1: 30.34,
    x2: 28.789,
    y1: 21.401,
    y2: 24.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-3st_svg__j",
    x1: 12.31,
    x2: 25.464,
    y1: 19.837,
    y2: 32.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-3st_svg__k",
    x1: 26.457,
    x2: 13.355,
    y1: 33.984,
    y2: 20.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-3st_svg__l",
    x1: 13.795,
    x2: 24.008,
    y1: 21.323,
    y2: 31.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-3st_svg__m",
    x1: 20,
    x2: 20,
    y1: 31.177,
    y2: 39.364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-3st_svg__n",
    x1: 27.47,
    x2: 17.169,
    y1: 34.012,
    y2: 27.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-3st_svg__o",
    x1: 17.402,
    x2: 22.087,
    y1: 25.154,
    y2: 29.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-3st_svg__p",
    x1: 22.807,
    x2: 16.332,
    y1: 26.432,
    y2: 29.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-3st_svg__q",
    x1: 21.116,
    x2: 17.571,
    y1: 28.732,
    y2: 27.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-3st_svg__r",
    x1: 18.883,
    x2: 22.429,
    y1: 28.732,
    y2: 27.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-3st_svg__s",
    x1: 18.962,
    x2: 21.241,
    y1: 28.909,
    y2: 25.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-3st_svg__t",
    x1: 20.863,
    x2: 20.673,
    y1: 28.446,
    y2: 24.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-3st_svg__u",
    x1: 26.146,
    x2: 21.336,
    y1: 22.258,
    y2: 13.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-3st_svg__v",
    x1: 20.558,
    x2: 23.656,
    y1: 4.442,
    y2: 9.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8E8F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-3st_svg__w",
    x1: 17.468,
    x2: 27.089,
    y1: -1.621,
    y2: 9.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBEC6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81B823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-3st_svg__x",
    x1: 15.424,
    x2: 25.045,
    y1: 0.158,
    y2: 11.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBEC6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81B823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-3st_svg__y",
    x1: 20,
    x2: 20,
    y1: 5.212,
    y2: 2.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78A91F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78A91F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-3st_svg__z",
    x1: 22.98,
    x2: 24.319,
    y1: 8.386,
    y2: 9.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78A91F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78A91F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-3st_svg__A",
    x1: 17.02,
    x2: 15.681,
    y1: 8.386,
    y2: 9.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78A91F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78A91F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-3st_svg__B",
    x1: 26.799,
    x2: 10.716,
    y1: 13.928,
    y2: -2.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-3st_svg__C",
    x1: 20.001,
    x2: 20.001,
    y1: 6.403,
    y2: 17.386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-3st_svg__D",
    x1: 20,
    x2: 20,
    y1: 12.784,
    y2: 16.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-3st_svg__E",
    x1: 23.707,
    x2: 21.511,
    y1: 10.736,
    y2: 12.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-3st_svg__F",
    x1: 18.314,
    x2: 22.473,
    y1: 13.216,
    y2: 17.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-3st_svg__G",
    x1: 21.196,
    x2: 19.137,
    y1: 16.101,
    y2: 14.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-3st_svg__H",
    x1: 20,
    x2: 20,
    y1: 0.889,
    y2: 2.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-rank-3st_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
};
export default SvgIconRank3St;